import axios from "axios";
import { LOGIN, LOGIN_FAIL, LOGOUT, USER_LOADED, USER_FAIL } from "./types";
import { REGISTER_OTP } from "./types";
import setAuthToken from "../Helpers/setAuthToken";
import { toast } from "react-toastify";

const PROXY = process.env.REACT_APP_URL + "api/";

const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

const config1={
  headers: {
    "Content-Type": "application/json",
    username:"ws-leigulistinn",
    password:"DbFc76",
    client_id:"WebAPI",
    client_secret:"sfagoij4w2t524t5jO09vnbcvknm5ry7uiw53yO"
  },
}

export const userLogin = (userObj) => async (dispatch) => {

  const body = JSON.stringify(userObj);
  const res = await axios.post(PROXY + "user/login", body, config);

  dispatch({
    type: LOGIN,
    payload: res.data,
    // type: USER_LOADED,
    // payload: res.data,
  });
  dispatch(loadUser());

  return res;
 
};

export const logout = () => async (dispatch) => {
  dispatch({
    type: LOGOUT,
  });
};
//eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6Im5pcmF2LmdhamVyYUBtYWlsaW5hdG9yLmNvbSIsImlkIjoiNjg4MDc2MjM3ZWY2MjQyNmVjY2RiZmVjIiwiaWF0IjoxNzU2ODgxMDEyLCJleHAiOjE3NTc3NDUwMTJ9.lexQAI8hram1efYR_-fnNFoavqU1mpmUQoWbnFpR2Tg

// Load User
export const loadUser = () => async (dispatch) => {

  if (localStorage.AppToken) {
    setAuthToken(localStorage.AppToken);
  }
  const userId = {
    id: localStorage.getItem("user"),
  };
  try {
    const res = await axios.post(PROXY + "user/auth", userId);
    dispatch({
      type: USER_LOADED,
      payload: res.data,
    });
    return res;
  } catch (error) {
    dispatch({
      type: USER_FAIL,
    });
  }
};

// update profile

export const updateProfile = (Obj) => async (dispatch) => {
  if (localStorage.AppToken) {
    setAuthToken(localStorage.AppToken);
  }
  const res1 = await axios.put(`${PROXY}user/edit`, Obj);
  dispatch(loadUser());
  return res1;
};

export const userRegisterOtp = (userObj) => async (dispatch) => {
  // try {
  const body = JSON.stringify(userObj);
  const res = await axios.post(PROXY + "user/register-otp", body, config);

  dispatch({
    type: REGISTER_OTP,
    payload: res.data,
  });

  return res;
  // }
  //  catch (error) {
  //   dispatch({
  //     type: LOGIN_FAIL,
  //   });
  //   toast.error(error.response.data.message);
  //   return error;
  // }
};

// change password

export const changePassword = (objPassword) => async (dispatch) => {
  const body = JSON.stringify(objPassword);
  try {
    const res = await axios.post(PROXY + "user/change_password", body, config);
    // toast.success(res.data.message, "success");"0101131480"
    return res;
  } catch (error) {
    if (error.response.data.message) {
      toast.error(error.response.data.message);
    } else {
      toast.error(error.response.data.message);
    }
  }
};

export const getUserDetailsFromSocialId =(id) => async () => {

  try{
    const res= await axios.get (PROXY + "user/get-user-national-details/"+id)
    return res
  }catch (err){
    return err.response.data

  }
}

export const addBasicInfo = (data) => async (dispatch) => {
  if (localStorage.AppToken) {
    setAuthToken(localStorage.AppToken);
  }

  try {
    const res = await axios.put(`${PROXY}user/basic-info`, data);

    // toast.success(res.data.message);
    dispatch(loadUser());
    return res;
  } catch (err) {
    // toast.error(err.response.data.message);
    return err;
  }
};
